/**
 * Cache no localStorage (24 h por padrão) para dados de referência que mudam pouco (catálogo de fontes,
 * categorias do Google Maps). Uma entrada por prefixo: gravar outra chave do mesmo prefixo
 * (outro idioma, outra marca) apaga a anterior. Sem storage, o dado vale só na página aberta.
 */
export const DAILY_TTL_MS = 24 * 60 * 60 * 1000;
/** Um mês: as categorias do Google Maps quase não mudam. */
export const MONTHLY_TTL_MS = 30 * DAILY_TTL_MS;

export interface DailyEntry<T> {
  savedAt: number;
  data: T;
}

export function readDaily<T>(
  key: string,
  isValid: (data: unknown) => data is T,
  now = Date.now(),
  ttlMs = DAILY_TTL_MS,
): DailyEntry<T> | undefined {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as DailyEntry<unknown>;
    if (!parsed || !isValid(parsed.data)) return undefined;
    if (!Number.isFinite(parsed.savedAt) || now - parsed.savedAt >= ttlMs) return undefined;
    return parsed as DailyEntry<T>;
  } catch {
    return undefined;
  }
}

export function writeDaily<T>(prefix: string, key: string, data: T, now = Date.now()): void {
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const existing = localStorage.key(i);
      if (existing?.startsWith(prefix) && existing !== key) localStorage.removeItem(existing);
    }
    localStorage.setItem(key, JSON.stringify({ savedAt: now, data }));
  } catch {
    // Sem espaço ou sem storage: vale só enquanto a página estiver aberta.
  }
}
